import Result from "@/core/common/Result";

export type SalvarAgendamentoParams = {
  uri: string;
  tipo: number;
};

export interface ICriarAgendamentoGateway {
  criarAgendamento(params: SalvarAgendamentoParams): Promise<Result<void>>;
}

export const criarAgendamentosGatewayDI = "criarAgendamentosGatewayDI";
